export default __webpack_public_path__ + "static/media/success.e77eb07e.svg";